import React from "react";
import PropTypes from 'prop-types';
import "./styles.scss";

const Switch = props => {
  const handleClick = () => {
    props.onChange(!props.checked);
  };

  return (
    <div
      className={`
        chs-switch
        ${props.checked ? 'active' : ''}
        chs-switch-${props.size ? props.size : 'md'}
        chs-switch-${props.variant ? props.variant : ''}
        ${props.className ? props.className : ''}
      `}
      onClick={handleClick}
    >
      <div className={`chs-switch-indicator ${props.indicatorClassName || ""}`}></div>
    </div>
  );
};

Switch.propTypes = {
  onChange: PropTypes.func,
  checked: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'lg', 'md']),
  variant: PropTypes.oneOf(["principal", "green", "infos", "red", "blue", "black", "gray"]),
};

Switch.defaultProps = {
  onChange: () => console.log("Please attach an onHide function to [Switch]"),
  checked: false,
  variant: "principal",
  size: "md",
  className: ""
};

export default Switch;